import { Component, OnInit, Output } from '@angular/core';
import { ApproveServiceService } from 'src/shared/services/approve-service.service';
import { ApproveRequestDetails } from 'src/Shared/model/ApproveRequestDetails';
import { ApproveResponseDetails } from 'src/Shared/model/ApproveResponseDetails';
import { PayLoadData } from 'src/Shared/model/PayLoadData';
import { SendApproveRequest } from 'src/Shared/model/SendApproveRequest';
import { FormGroup, FormBuilder, FormArray, FormControl } from '@angular/forms';
import { DecryptionService } from 'src/shared/services/decryption.service';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-approve',
  templateUrl: './approve.component.html',
  styleUrls: ['./approve.component.css'],
  providers: [ApproveServiceService, DecryptionService]

})
export class ApproveComponent implements OnInit {
  isLoading: boolean = false;
  items = [];
  selectedEmployeeNo: string[] = [];
  pageOfItems: Array<any>;
  request: ApproveRequestDetails = new ApproveRequestDetails();
  data: string;
  response: ApproveResponseDetails[];
  payload: PayLoadData;
  RequestDetails: SendApproveRequest;

  constructor(private service: ApproveServiceService, public decryptionServiceService: DecryptionService, private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    
    this.data = sessionStorage.getItem('data');
    this.payload = JSON.parse(this.data);
    this.request.EmployeeNo = this.payload.employeeNo;
    // this.response = 
    if (this.payload.employeeNo == null || this.payload.employeeNo == "" || this.payload.employeeNo == undefined) {
      this.router.navigate(['/unauthorize']);
    } else {
      if (this.payload.position < this.payload.approvePosition) {
        this.router.navigate(['/unauthorize']);
      }
      else {
        this.fetchUploadedData(this.request);
        this.items = Array(this.items.length).fill(this.response).map((x, i) => ({ id: (i + 1), name: `Item ${i + 1}` }));

      }
    }
  }

  fetchUploadedData(req: ApproveRequestDetails) {
    this.isLoading = true;
    this.decryptionServiceService.fetchUploadedData(req).subscribe((data: ApproveResponseDetails[]) => {
      this.response = data;
      this.items = data;
    });
    this.isLoading = false;
  }
  onChangePage(pageOfItems: Array<any>) {
    this.pageOfItems = pageOfItems;
  }
  SubmitAprrove() {
    
    this.RequestDetails = new SendApproveRequest();
    this.RequestDetails.EmployeesNo = this.selectedEmployeeNo;
    this.RequestDetails.ApproveBy = this.payload.employeeNo;
    this.SaveAprroveDetails(this.RequestDetails);

  }
  setPageItems(arrayItem: any[]) {
    this.items = Array().fill(arrayItem).map((x, i) => ({ id: (i + 1), name: `Item ${i + 1}` }));
  }
  SaveAprroveDetails(RequestDetails) {
    this.isLoading = true;;
    this.service.SaveAprroveDetails(RequestDetails).subscribe((data: ApproveResponseDetails[]) => {
      this.response = data;
      this.items = Array(this.items.length).fill(this.response).map((x, i) => ({ id: (i + 1), name: `Item ${i + 1}` }));
      this.pageOfItems = this.items;
      this.setPageItems(this.items);
    });
    this.isLoading = false;
  }
}
